import { createContext, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import CookieConsent from "react-cookie-consent";
//import { useLocation } from "react-router-dom"; 
import Header from "./components/Header/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Sertification from "./pages/Sertification";
import Learner from "./pages/Learner";
import FAQ from "./pages/FAQ";
import Contacts from "./pages/Contacts";
import Sitemap from "./pages/Sitemap";
import NotFound from "./pages/NotFound";

import { Language } from "./types/types";

const initialLanguageContext = {
  language: "lv" as Language,
  setLanguage: (language: Language) => {
    console.log(language);
  },
};

export const LanguageContext = createContext(initialLanguageContext);

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const loadGoogleAnalytics = () => {
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=G-BHYJV9RMB1"]`)) {
    return;
  }


  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-BHYJV9RMB1"; 
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", "G-BHYJV9RMB1"); 
};

function App() {
  const [language, setLanguage] = useState<Language>("lv");
  
  // Definējam tekstus banerim atkarībā no valodas
  const cookieTexts = {
    lv: {
      message: "Šī tīmekļa vietne izmanto sīkdatnes, lai nodrošinātu labāko lietošanas pieredzi.",
      button: "Piekrītu",
    },
    en: {
      message: "This website uses cookies to ensure you get the best experience on our website.",
      button: "I accept",
    },
    ru: {
      message: "Этот сайт использует файлы cookie для обеспечения наилучшего пользовательского опыта.",
      button: "Согласен",
    }
  };

  const currentTexts = cookieTexts[language] || cookieTexts.lv;
 
  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <Router>
        <div className="app">
          <Header />
          <main>
            <Routes>
              {/* Redirect from root path to /lv */}
              <Route path="/" element={<Navigate to="/lv" />} />
              {/* Latvian Routes */}
              <Route path="/lv">
                <Route index element={<Home />} />
                <Route path="par-mums">
                  <Route index element={<About type="about" />} />
                  <Route path="uznemums" element={<About type="company" />} />
                  <Route path="komanda" element={<About type="team" />} />
                  <Route
                    path="dokumenti"
                    element={<About type="documents" />}
                  />
                  <Route
                    path="pakalpojumi"
                    element={<About type="services" />}
                  />
                </Route>
                <Route path="kursi">
                  <Route index element={<Courses type="all" />} />
                  <Route path="pieteikties" element={<Courses type="apply" />} />
                  <Route path="tig" element={<Courses type="tig" />} />
                  <Route path="mag" element={<Courses type="mag" />} />
                  <Route path="mig" element={<Courses type="mig" />} />
                  <Route path="mma" element={<Courses type="mma" />} />
                  <Route
                    path="kvalifikacija"
                    element={<Courses type="qualification" />}
                  />
                  <Route
                    path="uznemumiem"
                    element={<Courses type="companies" />}
                  />
                  <Route
                    path="bezdarbniekiem"
                    element={<Courses type="unemployed" />}
                  />
                  <Route
                    path="stars"
                    element={<Courses type="stars" />}
                  />
                  <Route
                    path="ka-izveleties"
                    element={<Courses type="howToChoose" />}
                  />
                  <Route
                    path="40-stundu-kursi"
                    element={<Courses type="short" />}
                  />
                </Route>
                <Route path="sertifikacija" element={<Sertification />} />
                <Route path="izglitojamajiem" element={<Learner />} />
                <Route path="buj" element={<FAQ />} />
                <Route path="kontakti" element={<Contacts />} />
                <Route path="ppl" element={<About type="ppl" />} />
                <Route path="lapas-karte" element={<Sitemap />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              {/* English Routes */}
              <Route path="/en">
                <Route index element={<Home />} />
                <Route path="about">
                  <Route index element={<About type="about" />} />
                  <Route path="company" element={<About type="company" />} />
                  <Route path="team" element={<About type="team" />} />
                  <Route
                    path="documents"
                    element={<About type="documents" />}
                  />
                  <Route path="services" element={<About type="services" />} />
                </Route>
                <Route path="courses">
                  <Route index element={<Courses type="all" />} />
                  <Route path="apply" element={<Courses type="apply" />} />
                  <Route path="tig" element={<Courses type="tig" />} />
                  <Route path="mag" element={<Courses type="mag" />} />
                  <Route path="mig" element={<Courses type="mig" />} />
                  <Route path="mma" element={<Courses type="mma" />} />
                  <Route
                    path="qualification"
                    element={<Courses type="qualification" />}
                  />
                  <Route
                    path="companies"
                    element={<Courses type="companies" />}
                  />
                  <Route
                    path="unemployed"
                    element={<Courses type="unemployed" />}
                  />
                  <Route
                    path="stars"
                    element={<Courses type="stars" />}
                  />
                  <Route
                    path="how-to-choose"
                    element={<Courses type="howToChoose" />}
                  />
                  <Route
                    path="40-hour-courses"
                    element={<Courses type="short" />}
                  />
                </Route>
                <Route path="certification" element={<Sertification />} />
                <Route path="learner" element={<Learner />} />
                <Route path="faq" element={<FAQ />} />
                <Route path="contacts" element={<Contacts />} />
                <Route path="ppl" element={<About type="ppl" />} />
                <Route path="sitemap" element={<Sitemap />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              {/* Russian Routes */}
              <Route path="/ru">
                <Route index element={<Home />} />
                <Route path="o-nas">
                  <Route index element={<About type="about" />} />
                  <Route path="kompaniya" element={<About type="company" />} />
                  <Route path="komanda" element={<About type="team" />} />
                  <Route
                    path="dokumenty"
                    element={<About type="documents" />}
                  />
                  <Route path="uslugi" element={<About type="services" />} />
                </Route>
                <Route path="kursy">
                  <Route index element={<Courses type="all" />} />
                  <Route path="zapisatsya" element={<Courses type="apply" />} />
                  <Route path="tig" element={<Courses type="tig" />} />
                  <Route path="mag" element={<Courses type="mag" />} />
                  <Route path="mig" element={<Courses type="mig" />} />
                  <Route path="mma" element={<Courses type="mma" />} />
                  <Route
                    path="kvalifikaciya"
                    element={<Courses type="qualification" />}
                  />
                  <Route
                    path="kompanii"
                    element={<Courses type="companies" />}
                  />
                  <Route
                    path="bezrabotnye"
                    element={<Courses type="unemployed" />}
                  />
                  <Route
                    path="stars"
                    element={<Courses type="stars" />}
                  />
                  <Route
                    path="kak-vybrat"
                    element={<Courses type="howToChoose" />}
                  />
                   <Route
                    path="40-chasovye-kursy"
                    element={<Courses type="short" />}
                  />
                </Route>
                <Route path="sertifikaciya" element={<Sertification />} />
                <Route path="dlya-uchashchikhsya" element={<Learner />} />
                <Route path="faq" element={<FAQ />} />
                <Route path="kontakty" element={<Contacts />} />
                <Route path="ppl" element={<About type="ppl" />} />
                <Route path="karta" element={<Sitemap />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </main>
          <Footer />
          <CookieConsent
  location="bottom"
  buttonText={currentTexts.button}
  enableDeclineButton // Šī rinda ieslēdz pogu "Nepiekrītu"
  declineButtonText={
    language === "lv" ? "Nepiekrītu" : 
    language === "ru" ? "Не согласен" : "Decline"
  }
  cookieName="manaLapaCookieConsent"
  style={{ 
    background: "#5b5f61ff", 
    color: "#fff", 
    fontSize: "14px",
    padding: "10px 0"
  }}
  buttonStyle={{ 
    backgroundColor: "#4CAF50", 
    color: "#fff", 
    fontSize: "13px", 
    borderRadius: "4px",
    padding: "8px 20px",
    fontWeight: "bold"
  }}
  declineButtonStyle={{ 
    backgroundColor: "#ffffffff", 
    color: "#878787ff", 
    fontSize: "13px", 
    borderRadius: "4px",
    padding: "8px 20px"
  }}
  expires={150}
  onAccept={() => {
              localStorage.setItem("manaLapaCookieConsent", "true");
              loadGoogleAnalytics(); // GA ielādējas tikai pēc piekrišanas
            }}
            onDecline={() => {
              localStorage.setItem("manaLapaCookieConsent", "false");
            }}
>
  {currentTexts.message}
</CookieConsent>
        </div>
      </Router>
    </LanguageContext.Provider>
  );
}

export default App;
